import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BaseComponent } from 'src/app/core/components/base.component';
import { HelpTextService } from 'src/app/core/services/api-services';
import { HelpTextDialogComponent } from '../help-text-dialog/help-text-dialog.component';

@Component({
  selector: 'app-help-icon',
  templateUrl: './help-icon.component.html',
  styleUrls: ['./help-icon.component.scss']
})
export class HelpIconComponent extends BaseComponent implements OnInit {
  @Input() key!: string;
  @Input() alignRight: boolean = false;
  @Input() alignVerticalTop: boolean = false;
  @Input() alignVerticalMiddle: boolean = false;
  @Input() alignSelfCenter: boolean = false;
  @Input() dialogWidth: string | null = null;
  @HostBinding('class') class: string = '';
  // titleDeactivated: HelpTextDeactivatedModel;
  titleDeactivated: any;
   
  constructor(private readonly dialog: MatDialog,
    private readonly helpTextService: HelpTextService) {
    super();
  }

  ngOnInit(): void {
    this.helpTextService.titleDeactivated(this.key)
      .unsubscribeOnDestroy(this)
      .subscribe(value => {
        this.titleDeactivated = value;
      });

    if (this.alignRight) {
      this.class = 'text-end';
    }

    if (this.alignVerticalTop) {
      this.class = 'align-vertical-top';
    }

    if (this.alignVerticalMiddle) {
      this.class = 'align-vertical-middle';
    }
    
    if (this.alignSelfCenter) {
      this.class = 'align-self-center';
    }
  }

  openDialog(event: Event): void {
    event.stopPropagation();
    this.dialog.open(HelpTextDialogComponent, {
      width: this.dialogWidth ?? '530px',
      data: { key: this.key } 
    });
  } 
}
